import React, { FunctionComponent, useState, useEffect } from "react";
import { Button, CustomDatePicker, CustomSelect } from "../../../components";
import Grid from '@mui/material/Unstable_Grid2';
import { getAxios } from "../../../utils/endpoints";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import { User } from "../../../model/User";

type IProps = {
    value: string;
    onApply: (start: Date, end: Date) => void;
    onChange: (event: SelectChangeEvent<unknown>) => void;
}

export const BetweenDatesAndDealer: FunctionComponent<IProps> = (props): JSX.Element => {
    const user: User = new User();
    
    const dealers = user.Accounts.map((account) => {
        return {
            value: account.dealerId,
            label: account.companyName
        }
    });

    const [startDate, setStartDate] = useState<Date>(new Date());
    const [endDate, setEndDate] = useState<Date>(new Date());
    const [dealer, setDealer] = useState<string>("");
    
    return (
        <Grid container columns={{ xs: 12, sm: 12, md: 12 }} sx={{ width: "100%", mb: 2 }} columnSpacing={{ xs: 0, md: 2 }} rowSpacing={{ xs: 2, md: 0 }}>
            <Grid xs={12} md={4}>
                <CustomDatePicker
                    label={{ text: "Start Date" }}
                    value={startDate}
                    onChange={(newValue, keyInputValue) => setStartDate(newValue)}
                    width={"100%"}
                />
            </Grid>
            <Grid xs={12} md={4}>
                <CustomDatePicker
                    label={{ text: "End Date" }}
                    value={endDate}
                    onChange={(newValue, keyInputValue) => setEndDate(newValue)}
                    width={"100%"}
                />
            </Grid>
            <Grid xs={12} md={4}>
                <CustomSelect value={props.value} label="Dealer" onChange={props.onChange} >
                    <MenuItem value="all">All</MenuItem>
                    {
                        dealers.map((dealer, index) => {
                            return (
                                <MenuItem key={index} value={dealer.value}>{dealer.label}</MenuItem>
                            )
                        })
                    }
                </CustomSelect>
            </Grid>
            <Grid mt={2} xs={12} md={4} display="flex" alignItems="end">
                <Button width={120} height={40} label='Apply' onClick={() => props.onApply(startDate, endDate)} />
            </Grid>
            {/*state.errorMessage && <Typography color="red" fontSize={12}>{state.errorMessage}</Typography>*/}
        </Grid>
    )
}
